<template>
  <topbar
    :titulo="$t('ACADEMICO.HISTORICO_ESCOLAR')"
    :subtitulo="$t('ACADEMICO.HISTORICO_ESCOLAR_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.CURRICULO_ESCOLAR') },
        { titulo: this.$t('ACADEMICO.HISTORICO_ESCOLAR') },
      ],
    };
  },
  methods: {},
};
</script>
